import transformProps from '@didi/webx-ui-utils/src/transform-props'
import config from '../../../views/hxz/config'

const props = {
  info: {
    type: Object,
    value: () => config,
  },
  pageConfig: {
    type: Object,
    value: () => ({
      index: {
        style: {
          backgroundColor: '#5114B9',
        },
        button: {
          text: '立即领取',
          gotoText: '去使用',
        },
        link: 'https://x.huaxz.cn/l1aXEaD',
        alipay_link: 'https://x.huaxz.cn/x/mAqPErx',
        title: '天天领打车券',
      },
      rule: {
        link: '',
        style: {
          top: 40,
          color: '#FFFFFF',
          backgroundColor: 'rgba(0,0,0,.3)',
        },
      },
      redPacket: {
        _closeTitle: '花小猪福利券包',
      },
      popup: {
        button: {
          text: '去使用',
        },
      },
      header: {},
      imageList: [
        {
          image:
            'https://ut-static.udache.com/webx/ut/1Flg-hl9E_d2rJYeAr3jp.png',
          style: {
            marginTop: 40,
            width: 700,
          },
        },
      ],
    }),
  },
}

const { propsForView, propsForModel, propsForStory } = transformProps(props)

export { props, propsForView, propsForModel, propsForStory }
